import {
    Dialog,
    Box,
    Typography,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from '@mui/material';
import { EventRepeat } from '@mui/icons-material';
import MultipleDatePicker from '../../components/input/date/multiple/MultipleDatePicker';
import { Dispatch, SetStateAction } from 'react';
import { TFunction } from "i18next";

interface RescheduleDialogProps {
    open: boolean;
    onClose: () => void;
    selectedDates: Date[];
    setSelectedDates: Dispatch<SetStateAction<Date[]>>;
    scheduledDates: Date[];
    setScheduledDates: Dispatch<SetStateAction<Date[]>>;
    reason: string;
    setReason: Dispatch<SetStateAction<string>>;

    onSubmit: () => Promise<void>;
    t: TFunction;
}


export const RescheduleDialog = ({
    open,
    onClose,
    selectedDates,
    setSelectedDates,
    scheduledDates,
    setScheduledDates,
    reason,
    setReason,
    onSubmit,
    t,
}: RescheduleDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    overflow: 'hidden',
                },
            }}
        >
            {/* Minimal Header */}
            <Box sx={{ p: 2, pb: 1, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <EventRepeat sx={{ color: '#3498db', fontSize: '1.5rem' }} />
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1a237e' }}>
                    {t('periodical:validation.reschedule')}
                </Typography>
            </Box>

            <DialogContent
                sx={{
                    p: 2,
                    pt: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', px: 0.5 }}>
                    {t('periodical:validation.rescheduleInstruction')}
                </Typography>

                <Box
                    sx={{
                        bgcolor: '#f8f9fa',
                        borderRadius: 3,
                        p: 1,
                        border: '1px solid #f0f0f0',
                    }}
                >
                    <MultipleDatePicker
                        isDisabled={false}
                        selectedDates={selectedDates}
                        setSelectedDates={setSelectedDates}
                        scheduledDates={scheduledDates}
                        setScheduledDates={setScheduledDates}
                        disablePast={true}
                        hasRecurrence={false}
                    />
                </Box>

                <TextField
                    label={t('periodical:validation.reason')}
                    multiline
                    rows={3}
                    fullWidth
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                            bgcolor: '#fff',
                        },
                    }}
                />
            </DialogContent>

            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button
                    onClick={onClose}
                    sx={{ textTransform: 'none', fontWeight: 700, color: 'text.secondary' }}
                >
                    {t('button.cancel')}
                </Button>
                <Button
                    onClick={onSubmit}
                    variant="contained"
                    disabled={selectedDates.length === 0}
                    sx={{
                        borderRadius: 3,
                        px: 5,
                        bgcolor: '#3498db',
                        fontWeight: 700,
                        textTransform: 'none',
                        boxShadow: '0 4px 12px rgba(52, 152, 219, 0.2)',
                        '&:hover': { bgcolor: '#2980b9' },
                    }}
                >
                    {t('validation.confirmation')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};